
<template>
<div class='homepage_right' :class="{'closeBtn':pageshow}">
  <div class="topDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>台风信息</span>
      </div>
      <div class="more">
      </div>
    </div>
    <div class="chartMain" v-loading="loading1">
      <div class="typhooninfo">
        <div class="contain" v-if="tfarray.length">
          <div><span class="wordcolor">{{tfinfo.tfid}} <span>
            <el-select v-model="tfid" placeholder="请选择" popper-class="select-option" @change="tfinfoSel">
              <el-option v-for="item in tfarray" :key="item.tfid" :label="item.name" :value="item.tfid">
              </el-option>
            </el-select>
            </span></span><span class="distance">距永嘉：{{distance}}km</span></div>
          <div class="descrow"><span>等级：{{tfinfo.strong}}</span><span class="qiya">气压：<span class="wordcolor">{{tfinfo.pressure}}百帕</span></span><span class="fs">风速：<span class="wordcolor">{{tfinfo.speed}}m/s</span></span></div>
          <div class="descrow"><span>中心位置：<span class="wordcolor">东经{{tfinfo.lng}}° ，北纬{{tfinfo.lat}}°</span></span></div>
        </div>
        <div class="contain flexC" v-else>
          <img src="@/assets/homepage_img_ptcopy/notyphoon.png">
        </div>
      </div>
    </div>
  </div>
  <div class="centerDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>降雨预报</span>
      </div>
      <div class="more">
        <el-radio-group v-model="rainTime" size="mini" @change="rainTimec">
          <el-radio-button label="1小时"></el-radio-button>
          <el-radio-button label="3小时"></el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="chartMain" ref="centerDiv">
      <el-image v-if="rainTime=='1小时'" :src="rainforecast[0]" @click.native="onPreview()">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
      <el-image v-if="rainTime=='3小时'" :src="rainforecast[1]" @click.native="onPreview()">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
  </div>
  <div class="bomDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>雷达云图</span>
      </div>
      <div class="more">
        <el-radio-group v-model="pictype" size="mini">
          <el-radio-button label="雷达回波图"></el-radio-button>
          <el-radio-button label="卫星云图"></el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="chartMain">
      <iframe ref="iframe1" v-show="pictype=='雷达回波图'" src="https://smart.zj121.com/radarNew/index.html" width="100%" :height="height" frameborder="0" scrolling="auto"></iframe>
      <iframe ref="iframe2" v-show="pictype=='卫星云图'" src="https://slt.zj.gov.cn/col/col1513112/index.html" width="100%" :height="height" frameborder="0" scrolling="auto"></iframe>
    </div>
  </div>
  <div class="showBtn flexC"  @click="pageshow = !pageshow"><i class="el-icon-caret-right" :class="{'tran180':pageshow}"></i></div>
  <div class="showMapBtn flexC" :class="{'radioOpen':showRadioDiv}" @mouseover="showRadioDiv = true" @mouseout="showRadioDiv=false">
    <i class="el-icon-coin" v-show="!showRadioDiv"></i>
    <div class="navMain" v-show="showRadioDiv">
      <el-radio-group v-model="mapType" @change="radioChange">
        <el-radio :label="3">水利影像图</el-radio>
        <el-radio :label="1">水利交通图</el-radio>
        <el-radio :label="5">水利地形图</el-radio>
      </el-radio-group>
    </div>
  </div>
</div>
</template>

<script>
import api from '@/api/homepage_ptcopy'
export default {
  components: { },
  data () {
    return {
      loading1: false,
      loading2: false,
      loading3: false,
      height: '300',
      BeginTime: '',
      EndTime: '',
      rainTime: '1小时',
      pictype: '雷达回波图',
      tfarray: [],
      tfinfo: { tfid: '' },
      tfid: '',
      timer: null,
      weatherBoxList1: [
        { name: '未来1小时降水预报', value: 'pf1', url: '' },
        { name: '未来3小时降水预报', value: 'pf3', url: '' }
      ],
      rainforecast: ['', ''],
      pageshow: false,
      showRadioDiv: false,
      mapType: 3
    }
  },
  computed: {},
  watch: {},
  methods: {
    radioChange () { // 地图底图切换
      this.$emit('changeMap', this.mapType)
    },
    rainTimec (val) {
      // console.log(val)
    },
    onPreview () {
      this.$emit('showimg', this.rainforecast)
    },
    tfinfoSel (val) {
      this.tfarray.forEach(item => {
        if (item.tfid === val) {
          this.$set(this, 'tfinfo', item)
        }
      })
      this.distance = this.GetDistance(this.tfinfo.lat, this.tfinfo.lng, 28.273886, 120.690968).toFixed(2)
    },
    // 水位过程线
    getTyhoonActivity () {
      this.loading1 = true
      api.getTyhoonActivity().then(res => {
        this.loading1 = false
        let data = res.data
        if (data.length !== 0) {
          this.tfarray = data
          this.tfinfo = data[0]
          this.tfid = data[0].tfid
          this.distance = this.GetDistance(data[0].lat, data[0].lng, 28.273886, 120.690968).toFixed(2)
        }
      })
    },
    getCurrentTime (num) {
      let nowdate = new Date()
      nowdate.setTime(nowdate.getTime() - 24 * 60 * 60 * 1000 * Number(num))
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      let mm = nowdate.getMinutes()
      let time =
        year +
        '-' +
        (mon > 9 ? mon : '0' + mon) +
        '-' +
        (dd > 9 ? dd : '0' + dd) +
        ' ' +
        (hh > 9 ? hh : '0' + hh) +
        ':' +
        (mm > 9 ? mm : '0' + mm)
      return time
    },
    // 计算两坐标点的距离
    GetDistance (lat1, lng1, lat2, lng2) {
      var radLat1 = lat1 * Math.PI / 180.0
      var radLat2 = lat2 * Math.PI / 180.0
      var a = radLat1 - radLat2
      var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
      Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)))
      s = s * 6378.137 // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000
      return s
    },
    getPartImage() {
      let url1 = []
      this.weatherBoxList1.forEach((el) => {
        url1.push(el.value + '.png?_d=' + new Date().getTime())
      })
      api.getStsUrl({ urls: url1 }).then((res) => {
        res.data.result.forEach((el, i) => {
          this.rainforecast[i] = decodeURIComponent(res.data.result[i])
        })
      })
    }
  },
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.EndTime = this.getCurrentTime(0)
    this.BeginTime = this.getCurrentTime(1)
    this.getTyhoonActivity()
    let x = 10000
    let y = 0
    let rand = parseInt(Math.random() * (x - y + 1) + y)
    // this.getPartImage()
    this.$set(this.rainforecast, 0, 'https://www.qxjcfw.cn/zzd150pic/rainforecast_1.png?1=1&ref=' + rand)
    this.$set(this.rainforecast, 1, 'https://www.qxjcfw.cn/zzd150pic/rainforecast_3.png?1=1&ref=' + rand)
    this.$nextTick(() => {
      let centerDiv = this.$refs.centerDiv
      this.height = centerDiv.offsetHeight
    })
    this.timer = setInterval(() => {
      this.EndTime = this.getCurrentTime(0)
      this.BeginTime = this.getCurrentTime(1)
      this.getTyhoonActivity()
      this.$refs.iframe1.contentWindow.location.reload(true)
      this.$refs.iframe2.contentWindow.location.reload(true)
      let x = 10000
      let y = 0
      let rand = parseInt(Math.random() * (x - y + 1) + y)
      this.rainforecast[0] =
        'https://shzhfy.yj.gov.cn/proxy/zzdpic/rainforecast_1.png?1=1&ref=' + rand
      this.rainforecast[1] =
        'https://shzhfy.yj.gov.cn/proxy/zzdpic/rainforecast_3.png?1=1&ref=' + rand
    }, 1000 * 60 * 5)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang='less' scoped>
*{
  box-sizing: border-box;
}
.homepage_right{
  position: absolute;
  top: 80px;
  right: 20px;
  z-index: 500;
  width: 520px;
  height: calc(100% - 85px);
  color: #fff;
  // background-image: linear-gradient(269deg, rgba(0,23,84,0.00) 0%, rgba(0,36,116,0.85) 100%);
  background-color: #1e346a;
  transition: all 1s ease;
}
.topDiv{
  width: 100%;
  height: 174px;
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    background: rgba(0,0,0,0.2);
    .typhooninfo{
      font-size: 15px;
      width: 100%;
      height: 100%;
      padding: 15px 25px;
      color: #fff;
      /deep/ .el-select{
        height: 20px;
      }
      /deep/ .el-input{
        width: 100px;
      }
      /deep/ .el-input__inner{
        background-color: rgba(0,0,0,0);
        color: #fff;
        border:none;
      }
      .contain{
        width: 100%;
        height: 100%;
        .wordcolor{
          color:#00deff
        }
        .distance{
          margin-left: 30px;
        }
        .descrow{
          margin-top: 18px;
          .qiya,.fs{
            margin-left: 25px;
          }
        }
        img{
          width: 180px;
          height: 88px;
        }
      }
    }
  }
}
.centerDiv{
  width: 100%;
  height: calc((100% - 174px)/2);
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    background: rgba(0,0,0,0.2);
    img{
      width: 100%;
      height: 100%;
    }
    /deep/ .el-image{
      width: 100%;
      height: 100%;
    }
    /deep/ .image-slot{
      width: 100%;
      height: 100%;
      position: relative;
      i{
        width: 30px;
        height: 30px;
        font-size: 30px;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }
}
.bomDiv{
  width: 100%;
  height: calc((100% - 174px)/2);
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    background: rgba(0,0,0,0.2);
  }
}
.titleDiv{
  height: 48px;
  line-height: 48px;
  padding-left: 30px;
  padding-right: 10px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, rgba(60,110,251,1) , rgba(60,110,251,0)) 10;
  .title{
    font-size: 22px;
    height: 50px;
    align-items: center;
  }
  .more{
    font-size: 16px;
    cursor: pointer;
    /deep/ .el-radio-button__inner{
      color:#fff!important;
      background: rgba(0,0,0,0);
      padding-left: 10px;
      padding-right: 10px;
      border: none;
      border-radius: 0;
    }
    /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      background: #1f6fef;
    }
    /deep/ .el-input__inner{
      width: 120px;
      padding: 0;
      background: none;
      color: #fff;
      border: 0;
      text-align: center;
    }
  }
  .title_logo{
    height: 50px;
    margin-right: 10px;
    img{
      height: 20px;
    }
  }
  .icon{
    display: flex;
    height: 50px;
    align-items: center;
    margin-right: 10px;
    transform: skew(-31deg);
    div{
      &:nth-of-type(1){
        width: 15px;
        height: 18px;
        background: #3C6EFB;
      }
      &:nth-of-type(2){
        width: 10px;
        height: 18px;
        background: #F7E700;
      }
    }
  }
}
.showBtn{
  width: 30px;
  height: 45px;
  position: absolute;
  font-size: 16px;
  color: #fff;
  background: rgba(22,48,128,0.2);
  left: -30px;
  top: 50px;
  border: 1px solid #0878b4;
  box-shadow: 0 0 5px #0878b4;
  cursor: pointer;
  i{
    transform: rotate(0deg);
    transition: all 1s ease;
  }
  .tran180{
    transform: rotate(180deg);
  }
}
.showMapBtn {
  width: 30px;
  height: 45px;
  position: absolute;
  font-size: 16px;
  color: #fff;
  background: rgba(22,48,128,0.2);
  right: 520px;
  top: 100px;
  border: 1px solid #0878b4;
  box-shadow: 0 0 5px #0878b4;
  cursor: pointer;
  i {
    transform: rotate(0deg);
    transition: all 1s ease;
  }
  .navMain {
    padding: 15px 5px;
    /deep/ .el-radio {
      padding: 15px;
      display: block;
      font-size: 18px;
      margin-left: 25px;
      .el-radio__input.is-checked+.el-radio__label {
        color: #409EFF;
      }
      .el-radio__inner {
        width: 18px;
        height: 18px;
      }
    }
    /deep/ .el-radio__label {
      padding-left: 15px;
      font-size: 18px;
      color: #fff;
    }
  }
}
.radioOpen {
  width: 150px;
  height: auto;
}
.closeBtn {
  right: -520px;
}
/deep/ .el-loading-mask{
  background: rgba(0,0,0,0.6);
}

/deep/ .el-table{
  background: none!important;
}
/deep/ .el-table__body tr.current-row>td{
  background-color: #69A8EA !important;
  color: #fff;
}
/deep/.el-table__empty-text{
  color: #fff;
}
/deep/.el-table tr {
  background-color: rgba(0,0,0,0);
}
/deep/ .el-table th{
  color: #fff;
  padding: 5px 0;
  background: #3C6EFB;
  border-right: 1px solid #101e3e;
  border-bottom: 1px solid #101e3e;
}
/deep/ .el-table td{
  color: #fff;
  background: rgba(23,44,93,0.8);
  border-right: 1px solid #101e3e;
  border-bottom: 1px solid #101e3e;
}
/deep/ .el-table--border{
  border: 1px solid #101e3e;
}
/deep/ .el-table--border::after,.el-table::before{
  background: none;
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
  background: #0a37a0;
}
/deep/ .el-loading-mask{
  background: rgba(0,0,0,0.6);
}
.flexDiv {
    /* 横向排列 */
    display: flex;
    align-items: center;
}

.flexC {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexDivCol {
  /* 垂直居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flexFS {
  /* 左对齐 */
  justify-content: flex-start;
}

.flexFE {
  /* 右对齐 */
  justify-content: flex-end;
}

.flexSA {
  /* 每个项目两侧的间隔相等 */
  justify-content: space-around;
}

.flexSB {
  /* 两端对齐 */
  justify-content: space-between;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar{
  // width: 0px;
  height: 7px;
  background-color: rgba(0,0,0,0);
}
</style>
